
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.28 38H4.89a17.59 17.59 0 0133.39 0zM25.89 12.2a5.89 5.89 0 00-3.72-.2 6 6 0 00-3.53 2.67 8.23 8.23 0 00-9.47 2.64A6 6 0 001.67 19a12.58 12.58 0 0124.22-6.8zM10.73 3.86s6.38.49 8.12 10.8M10.33 4S5.12 7.7 9 17.42M13.43 14.33l5.22 18.71M21.71 11.5a8.26 8.26 0 10.9-5.12","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    